import React, { useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import { InputText } from '../../../common/components/Input/InputText';
import { isValidEmail } from '../../../common/utils/emailUtils';

// Define the interfaces
interface BookingOwner {
  ownerName: string;
  emailAddress: string;
}

interface BookingOwners {
  [key: string]: BookingOwner;
}

interface BookingOwnersComponentProps {
  bookingOwners: BookingOwners;
  bookingId: string;
}

interface BookingOwnersComponentProps {
  bookingOwners: BookingOwners;
  sendOwnerBookingConfirmation: (
    ownerAccountId: string,
    emailAddress: string,
    bookingId: string,
  ) => void; // Add handler as a prop
}

export const BookingOwnersEmailComponent: React.FC<
  BookingOwnersComponentProps
> = ({ bookingId, bookingOwners, sendOwnerBookingConfirmation }) => {
  // Create a state to track email addresses, initially using the owner’s email.
  // console.log(bookingOwners);
  const [updatedEmails, setUpdatedEmails] = useState(
    Object.fromEntries(
      Object.entries(bookingOwners).map(([ownerAccountId, owner]) => [
        ownerAccountId,
        owner?.emailAddress ?? '',
      ]),
    ),
  );

  // Handler to update the email in state when the user edits the text field
  const handleEmailChange = (ownerAccountId, newEmail) => {
    setUpdatedEmails(prevEmails => ({
      ...prevEmails,
      [ownerAccountId]: newEmail,
    }));
  };

  // Call the parent handler when sending the confirmation
  const handleSendConfirmation = (ownerAccountId: string) => {
    const emailToSend = updatedEmails[ownerAccountId]; // This will either be the updated or original email
    sendOwnerBookingConfirmation(ownerAccountId, emailToSend, bookingId); // Call the parent handler
  };

  return (
    <div>
      {Object.entries(bookingOwners).length > 0 && (
        <h3 className="h4 mb-16">Lähetä varausvahvistus omistajille</h3>
      )}
      {/* Check if there are any owners */}
      {Object.entries(bookingOwners).length === 0
        ? null
        : Object.entries(bookingOwners).map(
            ([ownerAccountId, bookingOwner]) => (
              <div className="mb-24" key={ownerAccountId}>
                <Form.Label htmlFor="clientEmail" className="required">
                  {bookingOwner.ownerName}
                </Form.Label>
                <InputGroup className="flex-nowrap">
                  <InputText
                    Id="ownerEmail"
                    Name="ownerEmail"
                    IsRequired
                    HandleChange={e =>
                      handleEmailChange(ownerAccountId, e.target.value)
                    }
                    Value={updatedEmails[ownerAccountId]}
                    ClassName="mb-0 flex-fill"
                  />
                  <Button
                    onClick={() => handleSendConfirmation(ownerAccountId)}
                    disabled={
                      !updatedEmails[ownerAccountId] || // disable if empty or undefined
                      !updatedEmails[ownerAccountId]
                        .split(';') // split string into array by ';'
                        .map(email => email.trim()) // trim spaces
                        .every(email => isValidEmail(email)) // check all emails are valid
                    }
                    className="ms-n8 px-16"
                  >
                    Lähetä
                  </Button>
                </InputGroup>
              </div>
            ),
          )}
    </div>
  );
};
